angular.module( 'acme.view.application.partners.detail', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.directive.history',
  'acme.common.directive.paymentOptions',
  'acme.view.application.partners.detail.controllers',
  'acme.view.application.partners.detail.membership'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var partnersDetail = {
        name: 'application.partners.detail',
        url: '/:id/detail',
        views: {
          "subview-main": {
            controller: 'PartnersDetailController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/partners/detail/detail.tpl.html'
          }
        },
        data: {
          pageTitle: 'Organization Information',
          enablePreferences: true
        },
        resolve: {
          PartnerData: [ '$stateParams', 'ApiService', function($stateParams, ApiService) {
            return ApiService.partners.detail($stateParams.id);
          }],
          CategoriesData: [ 'ApiService', function(ApiService) {
            return ApiService.partners.categories.list({
              page: 1,
              pageSize: -1,
              sortDirection: "asc",
              sortField: "name"
            });
          }]
        }
      };

    $stateProvider
      .state(partnersDetail);
});
